import gsap from "gsap";

const isDev = window.location.hostname.includes("localhost");
const walletCard = document.querySelector(".wallet-card");
const isFrontPage = location.pathname === "/";
const headerNavMain = document.querySelector(".header-nav-main");

let menuHeight = 0;
if (headerNavMain) {
  menuHeight = headerNavMain.clientHeight;
  window.addEventListener("resize", () => {
    menuHeight = headerNavMain.clientHeight;
  });
}

const checkPosition = () => {
  if (walletCard) {
    if (!isFrontPage || window.scrollY >= menuHeight) {
      walletCard.classList.add("small-card");
      // cardAnimate(true);
    } else {
      walletCard.classList.remove("small-card");
      // cardAnimate(false);
    }
  }
};

const cardAnimate = (isSmallCard: boolean) => {
  if (!walletCard) {
    return;
  }

  const cardTitleSpans = walletCard.querySelectorAll(
    ".wallet-card-211 span:not(.wallet-card-title)"
  );
  const cardLinkHelp = walletCard.querySelector(".link-help");
  const cardLinkSearchSpan = walletCard.querySelector(".link-search span span");
  const cardLinkSearchIcon = walletCard.querySelector(".link-search .iconBg-search");

  if (!cardTitleSpans || !cardLinkHelp || !cardLinkSearchSpan || !cardLinkSearchIcon) {
    return;
  }

  gsap.defaults({ duration: isFrontPage ? 0.2 : 0.01 });

  if (isSmallCard) {
    cardTitleSpans.forEach((span) => {
      gsap.to(span, { opacity: 0, width: 0, height: 0 });
    });
    gsap.to(cardLinkSearchSpan, { opacity: 0, width: 0, height: 0 });
    gsap.to(cardLinkSearchIcon, { opacity: 0, width: 0, height: 0 });
    gsap.to(cardLinkHelp, { opacity: 0, width: 0, height: 0 });

    setTimeout(() => {
      cardTitleSpans.forEach((span) => {
        span.style.display = "none";
      });
      cardLinkSearchSpan.style.display = "none";
      cardLinkSearchIcon.style.display = "none";
      cardLinkHelp.style.display = "none";
    }, 250);
  } else {
    cardTitleSpans.forEach((span) => {
      gsap.to(span, {
        opacity: 1,
        width: "fit-content",
        height: "auto",
        display: span.classList.contains("font-size-xs") ? "block" : "inline-block",
      });
    });
    gsap.to(cardLinkSearchSpan, {
      opacity: 1,
      width: "fit-content",
      height: "auto",
      display: "inline-block",
    });
    gsap.to(cardLinkSearchIcon, {
      opacity: 1,
      width: "30px",
      height: "30px",
      display: "inline-block",
    });
    gsap.to(cardLinkHelp, { opacity: 1, width: "auto", height: "auto", display: "flex" });
  }
};

if (walletCard) {
  checkPosition();
  window.addEventListener("scroll", checkPosition);
}

function isElementInViewport(el: Element) {
  const rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

const chatButtons = document.querySelectorAll('.js-chat-preview-toggle');

const openChatWallet = (event) => {
  event.preventDefault();
  if (!isDev) {
    gtag('event', 'chat', {});
  }

  const wallets = document.querySelectorAll('.wallet-card:not(.wallet-card-chat)');
  wallets.forEach((wallet) => {
    wallet.classList.toggle('is-hidden');
  })
  const chat = document.querySelector('.wallet-card-chat');
  if (chat) {
    chat.classList.toggle('is-shown');
    // check if chat is in view, if not, scroll to it
    if (!isElementInViewport(chat)) {
      chat.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
  
chatButtons.forEach((button) => {
  button.addEventListener('click', openChatWallet);
});
window.addEventListener('openChatWallet', openChatWallet);

const startChat = document.querySelector('.js-start-chat');
if (startChat) {
  startChat.addEventListener('click', (event) => {
    event.preventDefault();
    const diviccw = document.getElementById('divicw');
    diviccw?.classList.add('nudge-over-exit-button');
    const script = document.createElement('script');
    script.src = 'https://media.imi.chat/widget/js/imichatinit.js';
    script.async = true;
    diviccw.appendChild(script);

    document.querySelector('.chat-backdrop')?.classList.add('is-shown');
    document.querySelector('.wallet-card-chat')?.classList.remove('is-shown');
    const wallets = document.querySelectorAll('.wallet-card:not(.wallet-card-chat)');
    wallets.forEach((wallet) => {
      wallet.classList.toggle('is-hidden');
    })

    script.addEventListener('load', () => {
      // console.log('done?', imichatwidget);
      // imichatwidget.on("imichat-widget:ready", function(appId){
        // console.log('imichat-widget:ready');
        setTimeout(() => {
          imichatwidget.show();
          imichatwidget.maximizeWindow();
        }, 100);
      // });

      // is there a close event? imichatwidget.on("imichat-widget:close", function(appId){
        // hide the backdrop

    });

    // const e = "https://media.imi.chat/widget/js/imichatinit.js";
    // try {
    //     const o = new XMLHttpRequest;
    //     o.onreadystatechange = function() {
    //       if (this.readyState == 4) {
    //           const t = document.getElementById("divicw");
    //           const e = document.createElement("script");
    //           e.innerHTML = this.responseText;
    //           if (t && t.parentNode) {
    //             t.parentNode.insertBefore(e, t.nextSibling);
    //           }
    //           // e.addEventListener("load", function() {
    //             console.log('done?');
    //             setTimeout(() => {
    //               console.log('trigger?');
    //               // imichatwidget.on("imichat-widget:ready", function(appId){
    //                 // var loadedAppId = appId;
    //                 //do anything here
    //                 imichatwidget.show();
    //                 imichatwidget.maximizeWindow();
    //               // });
    //             }, 1000);
    //           // });
    //       }
    //     };
    //     o.open("GET", e, true);
    //     o.send()
    // } catch (s) {
    //     console.error(s)
    // }
  });
}

const closeChat = document.querySelector('.chat-backdrop .button');
if (closeChat) {
  closeChat.addEventListener('click', (event) => {
    document.querySelector('.chat-backdrop')?.classList.remove('is-shown');
    imichatwidget.minimizeWindow();
  });
}
